module.exports = __webpack_public_path__ + "static/media/RP-81.12ddda5b.pdf";